import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { RangeComponent } from '../../../../../core/shared/ui/range/range.component';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BaseComponent } from '../../../../../core/shared/base.component';
import { TestsService } from '../../../../../core/services/tests.service';

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [RangeComponent, CommonModule],
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss',
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({ height: 0, padding: 0, opacity: 0, margin: 0, overflow: 'hidden' })),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('500ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
    ])
  ]
})
export class TestCardComponent extends BaseComponent implements OnChanges {
  @Input() test: any;
  @Output() nextTest: EventEmitter<void> = new EventEmitter<void>();
  @Output() verResultados: EventEmitter<void> = new EventEmitter<void>();
  private testService: TestsService = inject(TestsService);
  expandedIndex: number | null = null;
  currentQuestionIndex: number = 0;
  currentValueNow: number = 0;
  currentValueFuture: number = 0;
  showTodayCheckIcon: boolean = false;
  showFutureCheckIcon: boolean = false;
  activeRangeToday: boolean = false;
  activeRangeFuture: boolean = false;
  mostrandoResultados: boolean = false;
  dimensionSeleccionada: any = null;

  toggleExpand(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
    this.currentQuestionIndex = 0;
    if(this.expandedIndex !== null) {
      this.currentValueNow = this.test.dimensions[this.expandedIndex].questions[this.currentQuestionIndex].answer.valueNow ?? 0;
      this.currentValueFuture = this.test.dimensions[this.expandedIndex].questions[this.currentQuestionIndex].answer.valueFuture ?? 0;
      this.updateCheckIcons();
    }
    this.resetActiveRanges();
  }

  nextDimension(i: number) {
    const newIndex = i + 1;
    if(newIndex >= this.test.dimensions.length) {
      this.nextTest.emit();
      return;
    }
    this.expandedIndex = newIndex;
    this.currentQuestionIndex = 0;
    this.currentValueNow = this.test.dimensions[this.expandedIndex].questions[this.currentQuestionIndex].answer.valueNow ?? 0;
    this.currentValueFuture = this.test.dimensions[this.expandedIndex].questions[this.currentQuestionIndex].answer.valueFuture ?? 0;
    this.updateCheckIcons();
    this.resetActiveRanges();
  }

  updateTestKnow(testId: string, dimensionName: string, questionName: string, questionAnswer: any) {
    let testKnow = {
      testId,
      dimensionName,
      questionName,
      questionAnswer
    }
    this.testService.updateTestKnow(testKnow).subscribe({
      next: async (res: any) => {
      },
      error: (err: any) => {
        console.log('err', err);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['test'] && !changes['test'].isFirstChange()) {
      this.resetComponent();
    }
  }

  resetComponent() {
    this.expandedIndex = null;
    this.currentQuestionIndex = 0;
    this.showTodayCheckIcon = false;
    this.showFutureCheckIcon = false;
    this.resetActiveRanges();
  }

  resetActiveRanges() {
    this.activeRangeToday = false;
    this.activeRangeFuture = false;
  }

  setActiveRangeToday() {
    this.activeRangeToday = true;
    this.activeRangeFuture = false;
  }

  setActiveRangeFuture() {
    this.activeRangeToday = false;
    this.activeRangeFuture = true;
  }

  nextQuestion(dimension: any) {
    if (dimension.questions[this.currentQuestionIndex].answer.valueNow === 0 || dimension.questions[this.currentQuestionIndex].answer.valueFuture === 0) {
      this.alert("Debe contestar la pregunta con un valores entre 1-10", "");
      return;
    }
    
    // Validar que el valor futuro sea mayor que el de hoy
    const valueNow = dimension.questions[this.currentQuestionIndex].answer.valueNow;
    const valueFuture = dimension.questions[this.currentQuestionIndex].answer.valueFuture;

    
    if (valueFuture < valueNow) {
      this.alert("El valor futuro debe ser mayor o igual que el valor actual", "<span style='font-size: 14px;'>Para una proyección adecuada, el valor a futuro debe reflejar un crecimiento respecto al presente.</span>");
      return;
    }
    
    this.updateTestKnow(this.test._id, dimension.name, dimension.questions[this.currentQuestionIndex].name, dimension.questions[this.currentQuestionIndex].answer);
    if (dimension.questions.length > this.currentQuestionIndex + 1) {
      this.currentQuestionIndex++;
      this.currentValueNow = dimension.questions[this.currentQuestionIndex].answer.valueNow ?? 0;
      this.currentValueFuture = dimension.questions[this.currentQuestionIndex].answer.valueFuture ?? 0;
      this.updateCheckIcons();
      this.resetActiveRanges();
    } else {
      this.currentQuestionIndex = 0;
      dimension.completed = true;
      this.resetActiveRanges();
    }
  }

  changeRangeToday(value: any, question: any) {
    this.currentValueNow = value;
    question.answer.valueNow = this.currentValueNow;
    this.showTodayCheckIcon = value > 0;
    this.setActiveRangeToday();
  }

  changeRangeFuture(value: any, question: any) {
    this.currentValueFuture = value;
    question.answer.valueFuture = this.currentValueFuture;
    this.showFutureCheckIcon = value > 0;
    this.setActiveRangeFuture();
  }

  updateCheckIcons() {
    if (this.expandedIndex !== null) {
      const currentQuestion = this.test.dimensions[this.expandedIndex].questions[this.currentQuestionIndex];
      this.showTodayCheckIcon = currentQuestion.answer.valueNow > 0;
      this.showFutureCheckIcon = currentQuestion.answer.valueFuture > 0;
    } else {
      this.showTodayCheckIcon = false;
      this.showFutureCheckIcon = false;
    }
  }

  // Función para formatear el título en viñetas
  formatQuestionTitle(title: string): string[] {
    // Dividir por signos de interrogación y filtrar elementos vacíos
    return title.split('?')
      .map(item => item.trim())
      .filter(item => item.length > 0)
      .map(item => item + '?');
  }

  getAverage(dimension: any, type: string) {
    let total = 0;
    if(type === 'now') {
      dimension.questions.forEach((question: any) => {
        total += question.answer.valueNow;
      });
    } else {
      dimension.questions.forEach((question: any) => {
        total += question.answer.valueFuture;
      });
    }
    return (total / dimension.questions.length).toFixed(1);
  }

  // Calcular el porcentaje de incremento entre hoy y futuro
  getPercentageIncrease(dimension: any): number {
    const avgNow = this.getAverageRaw(dimension, 'now');
    const avgFuture = this.getAverageRaw(dimension, 'future');
    
    if (avgNow === 0) return 0;
    
    const increase = ((avgFuture - avgNow) / avgNow) * 10;
    return Math.round(increase);
  }
  
  // Obtener el promedio como número (no como string formateado)
  getAverageRaw(dimension: any, type: string): number {
    let total = 0;
    if(type === 'now') {
      dimension.questions.forEach((question: any) => {
        total += question.answer.valueNow;
      });
    } else {
      dimension.questions.forEach((question: any) => {
        total += question.answer.valueFuture;
      });
    }
    return total / dimension.questions.length;
  }

  toggleResultados(dimension: any) {
    this.mostrandoResultados = !this.mostrandoResultados;
    this.dimensionSeleccionada = dimension;
  }

  verResultadosDimension() {
    this.verResultados.emit();
  }
}